import React, { useState } from 'react';
import { Button } from '@mantine/core';
import ConfirmModal from 'shared/components/ConfirmModal';
import { deleteCompany } from 'modules/Company/services/companyService';
import { useHistory } from 'react-router';
import { routes } from 'shared/constants/routes';
import { toast } from 'react-toastify';
import { useTranslations } from 'shared/translations/useTranslations';

// import './styles.scss';

const DeleteCompany = ({ id }) => {
  const translations = useTranslations();
  const [isOpen, setOpen] = useState();
  const [isLoading, setLoading] = useState();
  const history = useHistory();
  const onDelete = async () => {
    try {
      setLoading(true);
      setOpen(false);
      await deleteCompany(id);
      setLoading(false);
      history.push(routes.companies.list.path);
      toast.success(translations.companies.companyWasDeleted);
    } catch {
      toast.error(translations.global.somethingWentWrong);
    }
  };
  return (
    <>
      <ConfirmModal
        isOpen={isOpen}
        paragraph={
          <div>
            {translations.companies.deleteCompanyDesc1} {id}.
            <br /> {translations.companies.deleteCompanyDesc2}
          </div>
        }
        isLoading={isLoading}
        onClose={() => setOpen(false)}
        onConfirm={onDelete}
        title={translations.companies.deleteCompany}
        confirmLabel={translations.global.delete}
        cancelLabel={translations.global.cancel}
      />
      <Button color="red" buttonType="button" onClick={() => setOpen(true)} isLoading={isLoading}>
        {translations.global.delete}
      </Button>
    </>
  );
};

export default DeleteCompany;
